import axios from 'axios';
import qs from 'qs';
export class SpotifyAuthClient {
    constructor(clientId) {
        this.clientId = clientId;
        this.baseURL = 'https://accounts.spotify.com/api';
    }
    postRequest(url, data) {
        return axios({
            url: this.baseURL + url,
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify(data)
        })
            .then(res => res.data)
            .catch(err => { throw err.response; });
    }
    requestToken(code, redirect_uri, code_verifier) {
        return this.postRequest('/token', {
            code,
            code_verifier,
            redirect_uri,
            client_id: process.env.SPOTIFY_CLIENT_ID,
            grant_type: 'authorization_code',
        });
    }
    refreshToken(refresh_token) {
        return this.postRequest('/token', {
            refresh_token,
            client_id: this.clientId,
            grant_type: 'refresh_token',
        });
    }
}
